import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";
/**
 * Function to call ContractAlert P2 Alert API
 * @returns 
 */
export async function aglieOR(payload) {
  try {
    return await authenticatedFetch(URL.aglieOR, {
      method: "POST",
      body: JSON.stringify(payload)

    });
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }
}

/**
* Function to call Demand Supply API
* @param {Alert Id} alertId 
* @returns 
*/
export async function aglieDemandAPI(alertId, cbu_code, plantCode, week) {

  const requestObj = {
    "Alert Id": alertId,
    "CBU": cbu_code,
    "Plant": plantCode,
    "Week":week
  };

  try {
    return await authenticatedFetch(URL.agileDemandDetailsApi, {
      method: "POST",
      body: JSON.stringify(requestObj)
    });
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }
}

/**
 * Function to call Key Insight API
 * @param {CBU code} cbuCode 
 * @param {CBU description} cbuDescription
 * @returns 
 */
export async function agileKeyInsightApi(cbuCode, plantCode, cbuDescription, id, week,format) {

  const requestObj = {
    "CBU Description": cbuDescription,
    "CBU Code": cbuCode,
    "Plant": plantCode,
    "Alert_Id": id,
    "Week" : week,
    "Format" : format
  }
  try {
    return await authenticatedFetch(URL.agileKeyInsightApi, {
      method: "POST",
      body: JSON.stringify(requestObj)
    });
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }
}
/**
 * Function to call Weekly OR Alert API
 * @returns 
 */
export async function weeklyOR(email, type, role) {
  const requestObj = {
    "email": email,
    "type": type,
    "role": role
  };

  try {
    return await authenticatedFetch(URL.weeklyOR, {
      method: "POST",
      body: JSON.stringify(requestObj)
    });
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }
}


/**
 * Function to call Man Power Shortage API
 * @returns 
 */
export async function manpowerShortageAPI(email, type, role) {
  const requestObj = {
    "email": email,
    "type": type,
    "role": role
  };

  try {
    return await authenticatedFetch(URL.manpowerShortage, {
      method: "POST",
      body: JSON.stringify(requestObj)
    });
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }
}

// api for saving the other recommendation feedback
export async function otherRecommendationFeedback(payload) {

  try {
    return await authenticatedFetch(URL.otherRecommendationFeedback, {
      method: "POST",
      body: JSON.stringify(payload)
    });
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }
}


// api for saving the buyer comments
export async function buyerComment(payload) {

  try {
    return await authenticatedFetch(URL.buyerComment, {
      method: "POST",
      body: JSON.stringify(payload)
    });
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }
}

// api for saving the factory comments
export async function factoryComment(payload) {

  try {
    return await authenticatedFetch(URL.factoryComment, {
      method: "POST",
      body: JSON.stringify(payload)
    });
  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }
}